"use strict";

exports.__esModule = true;

exports.default = function (obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/helpers/objectDestructuringEmpty.js
// module id = 732
// module chunks = 0 1